import { SettingsButtons } from '../../../vendor_core/core/src/const/SettingsButtons';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import Layout from '../../../vendor_core/core/src/utils/Layout';
import Locale from '../../../vendor_core/core/src/utils/Locale';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import { ViewOrientation } from '../../../vendor_core/core/src/views/BaseView';
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import Settings from '../../../vendor_core/src/base/ui/VendorSettings'
import VendorModel from '../../../vendor_core/src/model/VendorModel';
import DoubleChanceConfig from '../../configs/DoubleChanceConfig';
import Utils from '../Utils';
import LogoHelper from './logo/LogoHelper';
export default class TRWSettings extends Settings {

    updateTitle() {
        let  pageNames = ViewManager.getLayer(DefaultLayers.MenuUI).setScene("open");
        let pgNamesMap = new Map([
            ["paytable", "ui_paytable"],
            ["settings", "ui_settings"],
            ["gameinfo", "ui_game_rules"],
        ])
        pageNames.sceneTextFields.forEach((el, name) => {
            if(name == pgNamesMap.get(this.currentSettingsPage)) {
                el.visible = true;
            } else {
                if (name !== "ui_sub_title") {
                    el.visible = false;
                }
            }
        })
    }

    public show(arg: string) {
        super.show(arg);

        this.interfaceScene.buttons.get(SettingsButtons.HOME).visible = false;
    }

    public hide() {
        if (
            (this.scene["orientation"] === ViewOrientation.Landscape && Layout.isLandscape())
            || (this.scene["orientation"] === ViewOrientation.Portrait && !Layout.isLandscape())
        ) {

            ViewManager.resetLayersZOrder();
            Utils.changeBottomBarAlpha(0.7);
        }
        super.hide();
    }

    protected addSpecificPageRestrictions() {
        super.addSpecificPageRestrictions();

        if (VendorModel.settings?.scatterBoostDisable === "true") {
            this.hasRestrictions.set("paytable12", () => true);
        }

        if (VendorModel.settings?.disableBuyFeature === "true") {
            this.hasRestrictions.set("paytable13", () => true);
        }
    }
}
